module.exports = "/_next/static/images/fee6df177ecf874120ce08215c96a260-bill-filling-package.png";